import { gql } from '__generated__'

export const GetProcessStatuses = gql(/* GraphQL */ `
    query GetProcessStatuses {
        processStatuses {
            id
            status
            statusLabel
            processStatusSummaryGroup {
                id
                summaryGroup
                label
            }
        }
    }
`)
